<script setup lang="ts">
import { defineProps,defineEmits, onUnmounted, onMounted, ref, reactive, watch} from "vue";
import axios from 'axios'
import AxiosVideoService from "../utils/axiosVideoService";
import { useLanguage } from "../utils/useLanguage";

const { t } = useLanguage();
const axiosVideoService = new AxiosVideoService();
const axiosWithToken = axios.create({
  withCredentials: true,  // axios 專用設定，不是 header
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.token ?? ''}`,
  },
});


const loadingInfo = reactive({
    status: false,
    title: "Video processing",
})
const modalInfo = reactive({
    type: "alert",
    status: false,
    title: "Fail!",
    content: t('subtitleGenerationFailed'),
    msg: "chatnow"
})
const emit = defineEmits(['update:status'])
const props = defineProps({  
    status: {
        type: Boolean,
        required: false,
    }
})

const boolChange = () => {
    emit('update:status',false)
}
const vocabularyData = ref({
    id: "",
    text: "",
    pronunciation: "",
    meaning: "",
    user_saved: false
})
/* Save Vocabulary 儲存單字 */
function saveVb(vocabulary: any){
    loadingInfo.status = true
    loadingInfo.title = 'Saving Vocabulary'
    
    axiosWithToken.post("/api/v1/vocabulary/save/"+ vocabulary.id)
    .then((res: any) => {
        vocabulary.user_saved = true;
        loadingInfo.status = false
      console.log('add vocabulary',res.data);
    })
    .catch((res: any) => {
        vocabulary.user_saved = false;
        modalInfo.status = true
        modalInfo.msg = "confirm"
        modalInfo.title = "Something Wrong"
        modalInfo.content = "Sorry, failed to save the vocabulary. Please try again."

        loadingInfo.status = false

        console.log('add vocabulary failed',res);
    })
}
/* History List 單字 */
let allHistory: any = ref([]);

let vhCount: any = ref(20);
let vhPage: any = ref(0);
let cVhPage: any = ref(0);
function getVocsHistory(page: number, size: number){
    axiosVideoService.VocabularyHistoryList(localStorage.token, page, size, learning_language.value)
    .then((res: any) => {
        // let pages = res.data.pages
        
        vhPage.value = res.data.pages
        cVhPage.value = res.data.page
            
        let hisArr:any = res.data.items
        // 按照時間排序
        hisArr = hisArr.sort(function (a:any, b:any) {
            return a.updated_at < b.updated_at ? 1 : -1;
        });
           
        for(let i = 0; i < hisArr.length; i++){
            allHistory.value.push(hisArr[i])
        }


    })
    .catch((r: any) => {
        console.log('vocablary list failed',r.data);
    })
    
}
watch(() => props.status, (newStatus) => {
    allHistory.value = []
    getVocsHistory(1, vhCount.value)
});
const learning_language = ref()
onMounted(() => {

    learning_language.value = localStorage.getItem('learningLanguage')
    getVocsHistory(1, vhCount.value)
})
</script>
<template >
 <div class="fixed bg-white-1 hisModal" :class="[props.status ? 'open': '']">
    <div class="hisHeader title-2 white-1 flex j-between bg-sd">Your Vocabulary History<div class="icon-close pointer white-1" @click="boolChange()"></div></div>

    <div class="hisContent bg-white-1 scroll">
        <h2 class="title-1 mb-10">Your Vocabulary History</h2>
        <div>

            <ul class="flex column gap-10">
                <li  v-for="(item, index) in allHistory" :key="index" class="h-card bg-white-4">
                    <span :id="'vb'+item.id" class="icon-heart-circle-filled md pointer" :class="item.user_saved? 'dark':''" @click="saveVb(item)" v-if="item.id"></span> 
                    <div class="flex a-center gap-5">

                        <p class="font-2 bold">{{ item.text }}</p>
                        <p class="font-3 black-3">{{ item.pronunciation }}</p>
                        <span class="icon-eye black-4"></span> <span class="black-4">{{ item.lookup_count }}</span>
                        
                    </div>
                    <p class="font-3">{{ item.meaning }}</p>
                
                </li>
            </ul>
        </div>
            
  

        <div class="t-center p-20" v-if="(cVhPage < vhPage) && (allHistory.length > 0)">
                <div class="btn capsule outline br-black black-1" @click="getVocsHistory((cVhPage + 1), vhCount)" >See More History</div>
        </div>
    </div>
</div>
<Loading v-model:status="loadingInfo.status" v-model:title="loadingInfo.title"></Loading>
<Modal v-model:type="modalInfo.type" v-model:title="modalInfo.title" v-model:content="modalInfo.content" v-model:status="modalInfo.status" v-model:msg="modalInfo.msg"/>


</template>
<style scoped>
@import '../assets/css_lib/themimir.css';

.hisModal{
    z-index: 999999;
    left: 50%;
    transform: translate(-50%, -50%);
    top: calc(100% + 50vh);
    transition: all .5s ease;
}
.hisModal.open{
    top: 50%;
}
.hisHeader{
    padding: 16px;
    border-bottom: .0625rem solid #f3f3f3;
}
.hisContent{
    padding: 20px 25px 50px;
    width: 80vw;
    height: calc(80vh - 130px);
}
@media all and (max-width: 540px) {
    .hisHeader{
        height: 60px;
    }
    .hisContent{
        width: 100vw;
        height: calc(100vh - 60px);
        
    }

}
@media (orientation: landscape) and (max-width: 960px) {
    .hisContent{
        height: calc(90vh - 80px);

    }
}
.h-card{
    border-radius: 5px;
    padding: 20px;
}

</style>